/**
 * inventoryConstants — leaf module for inventory enums.
 *
 * Lives outside InventoryContext.jsx so it can be imported by helpers
 * (useInventoryData, inventoryColumns) without creating a circular
 * dependency back into InventoryContext. InventoryContext.jsx re-exports
 * these for backwards compatibility — existing consumers can keep
 * importing from './InventoryContext'.
 */

export const VIEW_MODES = {
  LIST: 'list',
  GROUPED: 'grouped',
  GRID: 'grid',
};

// The UNIT on screen (plan §3.4c): the inventory as uploaded (one row per file) or as
// detected (one row per document found inside the files). Every view mode, filter,
// sort, count and bulk action applies inside whichever unit is chosen.
export const UNITS = {
  FILES: 'files',
  DOCUMENTS: 'documents',
};

export const SORT_KEYS = {
  FILENAME: 'filename',
  DATE: 'date',
  SIZE: 'size',
  EXTENT: 'extent',
  COST: 'cost',
  TYPE: 'type',
  STATUS: 'status',
};
